import { memo } from "react";

interface DieProps {
  value: number;
  held: boolean;
  disabled: boolean;
  onToggleHold: () => void;
  onKeyDown?: (e: React.KeyboardEvent) => void;
}

const DOT_POSITIONS: Record<number, Array<[number, number]>> = {
  1: [[50, 50]],
  2: [
    [25, 25],
    [75, 75],
  ],
  3: [
    [25, 25],
    [50, 50],
    [75, 75],
  ],
  4: [
    [25, 25],
    [75, 25],
    [25, 75],
    [75, 75],
  ],
  5: [
    [25, 25],
    [75, 25],
    [50, 50],
    [25, 75],
    [75, 75],
  ],
  6: [
    [25, 25],
    [75, 25],
    [25, 50],
    [75, 50],
    [25, 75],
    [75, 75],
  ],
};

export const Die = memo(function Die({ value, held, disabled, onToggleHold, onKeyDown }: DieProps) {
  const dots = DOT_POSITIONS[value] ?? [];

  return (
    <button
      type="button"
      className={`die ${held ? "die--held" : ""}`}
      onClick={onToggleHold}
      onKeyDown={onKeyDown}
      disabled={disabled}
      aria-label={`Die ${value}${held ? ", held" : ""}${disabled ? "" : ". Press to hold"}`}
      aria-pressed={held}
    >
      <svg viewBox="0 0 100 100" className="die__face">
        <rect
          x="2"
          y="2"
          width="96"
          height="96"
          rx="12"
          className="die__background"
        />
        {dots.map(([cx, cy], index) => (
          <circle key={index} cx={cx} cy={cy} r="10" className="die__dot" />
        ))}
      </svg>
      {held && <span className="die__held-label">HOLD</span>}
    </button>
  );
});
